import { useSubscription } from "@apollo/client";
import { SERVICE_SUBSCRIPTION } from "@/graphql/subscriptions";

/**
 * Service Subscription Hook
 *
 * Subscribes to service events (create, update, delete) and automatically
 * refetches relevant queries when events occur.
 *
 * Uses the simple refetch approach (like appointments) for reliable cache updates.
 *
 * @param salonId - The salon ID to subscribe to
 */
export const useServiceSubscription = (salonId: string | undefined) => {
  useSubscription(SERVICE_SUBSCRIPTION, {
    variables: {
      filters: { salonId: salonId || "" },
    },
    skip: !salonId,
    onData: ({ client }) => {
      // Simple refetch approach - let server handle cache updates
      // This ensures consistency and reduces complexity
      client.refetchQueries({
        include: ["ServicesWithCategories"],
      });
    },
  });
};
